import { AuthenticatedLayout } from "@components/layouts/AuthenticatedLayout";
import { TemplateSessionsView } from "@containers/templateSessions/TemplateSessionsView";

const TemplateSessionsPage = () => {
    return (
        <AuthenticatedLayout activeMenuItem="templates">
            <TemplateSessionsView />
        </AuthenticatedLayout>
    );
}

export default TemplateSessionsPage;